import React from "react";
import { FileStack } from "lucide-react";
import SolutionPageLayout from "./SolutionPageLayout";

// Pathway 4 (Family D) — Document-Intensive & Regulated Service Environments
const ElectronicDocument = () => (
  <SolutionPageLayout
    testId="page-solution-electronic-document"
    icon={FileStack}
    overline="Pathway · 04 of 07 · Aligned with Family D"
    title="For Document-Intensive & Regulated Service Environments"
    headline="Stronger control over records and institutional memory in environments where documents, approvals, archives, correspondence, verification, access rights, and traceability are central to daily operations."
    intro={[
      "For institutions where documents, approvals, archives, correspondence, records, verification, access rights, and traceability are central to daily operations.",
      "This pathway is relevant for public institutions, universities, hospitals, clinics, laboratories, chambers, unions, regulated service providers, professional organizations, and other document-heavy environments that require stronger control over records and institutional memory.",
    ]}
    supportsOverline="Relevant use cases may include"
    supportsTitle="Where this pathway creates institutional value."
    supports={[
      "Electronic document management",
      "Digital archive management",
      "Document verification",
      "Internal correspondence workflows",
      "Approval and routing structures",
      "Archive scanning and digitization",
      "Document tracking and institutional memory",
      "Regulated service records",
      "Evidence, supporting documents, and traceable approvals",
      "Electronic signature, timestamp, registered electronic mail, e-archive, e-invoice, and e-ledger readiness where legally and technically available",
    ]}
    ctaTitle="Bring documents, records, and regulated workflows under a more structured digital control."
    primaryCta={{ label: "Discuss Document Pathway", to: "/contact" }}
    secondaryCta={{ label: "View Product Portfolio", to: "/product-portfolio#document-records-digital-transformation" }}
  />
);

export default ElectronicDocument;
